import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute("content") : ""
  }

  resend(event) {
    if (event) event.preventDefault()

    fetch(this.urlValue, {
      method: "GET",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      },
      redirect: "follow"
    })
      .then(response => {
        if (response.ok) {
          this.showToast("success")
        } else {
          this.showToast("error")
        }
      })
      .catch(() => this.showToast("error"))
  }

  showToast(variant) {
    const container = document.getElementById("onboarding-toast-container")
    const template = document.getElementById(`email-resend-toast-${variant}-template`)
    if (!container || !template) return

    container.innerHTML = template.innerHTML
  }
}
